import React, { useState } from "react";
import cn from "classnames";
import { useRouter } from "@contexts/RouterContext";
import { Link } from "react-router-dom";
import Sidebar from '@components/new/Sidebar';
import Header from '@components/new/Header';
import BackIcon from "@assets/icons/back-grey.svg";
import styles from "./Page.module.scss";

interface PageProps {
  title?: string;
  description?: string;
  children?: React.ReactNode;
  backLink?: string;
  actions?: React.ReactNode | null;
}

const Page = ({ backLink, title, description, children, actions }: PageProps) => {
  const { prevPath, prevSearch } = useRouter();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState<boolean>(localStorage.getItem("isSidebarCollapsed") === 'true');

  const handleSidebarCollapsed = () => {
    localStorage.setItem("isSidebarCollapsed", String(!isSidebarCollapsed));
    setIsSidebarCollapsed(!isSidebarCollapsed);
  }

  return (
    <div className={cn(styles.page, isSidebarCollapsed && styles.collapsed)}>
      <Sidebar isCollapsed={isSidebarCollapsed} />
      <Header
        title={title ?? ""}
        description={description}
        isSidebarCollapsed={isSidebarCollapsed}
        switchIsSidebarCollapsed={handleSidebarCollapsed}
      />
      <main className={styles.main}>
        {(backLink || actions) ? (
          <div className={styles.title}>
            {backLink ? (
              <Link to={(prevPath === backLink) ? `${prevPath}${prevSearch}` : backLink}>
                <img src={BackIcon} alt="" />
              </Link>
            ) : null}
            {actions ? (
              <div className={styles.actions}>{actions}</div>
            ) : null}
          </div>
        ) : null}
        <div className={styles.content}>{children}</div>
      </main>
    </div>
  );
};

export default Page;
